import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { SITE } from "../lib/constants";

const Locations = () => {
  const { t } = useLanguage();

  return (
    <section
      id="locations"
      data-testid="locations-section"
      className="section-padding bg-white"
    >
      <div className="container-page">
        <div className="max-w-3xl">
          <span className="chip mb-5">{t.locations.eyebrow}</span>
          <h2 className="font-display font-black text-4xl sm:text-5xl text-navy leading-[1.05]">
            {t.locations.title}
          </h2>
          <p className="mt-5 text-base md:text-lg text-foreground/75 leading-relaxed">
            {t.locations.lead}
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6">
          {t.locations.sites.map((site, i) => (
            <article
              key={i}
              data-testid={`location-card-${i}`}
              className="group rounded-2xl overflow-hidden border border-border bg-white card-hover lg:grid lg:grid-cols-12"
            >
              <div className="relative aspect-[16/10] lg:aspect-auto lg:col-span-8 overflow-hidden bg-[#F1F5F9]">
                <img
                  src={site.image}
                  alt={site.name}
                  className="h-full w-full object-contain lg:object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                  width="1600"
                  height="900"
                />
                <div className="absolute left-4 top-4 rounded-full bg-white/95 backdrop-blur px-3 py-1 text-[10px] font-bold uppercase tracking-[0.18em] text-navy">
                  <i className="fa-solid fa-hospital mr-2 text-[#FF5A1F]" aria-hidden="true"></i>
                  {site.role}
                </div>
              </div>
              <div className="p-7 lg:p-9 lg:col-span-4 lg:flex lg:flex-col lg:justify-center">
                <h3 className="font-display text-2xl lg:text-3xl font-bold text-navy">
                  {site.name}
                </h3>
                <address className="mt-3 not-italic text-sm text-foreground/75 leading-relaxed">
                  <p className="flex items-start gap-2">
                    <i className="fa-solid fa-location-dot text-[#FF5A1F] mt-1" aria-hidden="true"></i>
                    <span>
                      {site.address}
                      <br />
                      {site.city}
                    </span>
                  </p>
                  <p className="mt-2 flex items-center gap-2">
                    <i className="fa-solid fa-phone text-[#FF5A1F]" aria-hidden="true"></i>
                    <a
                      href={SITE.phoneHref}
                      data-testid={`location-phone-${i}`}
                      className="hover:text-[#FF5A1F] transition"
                    >
                      {site.phone}
                    </a>
                  </p>
                </address>
                <div className="mt-5 flex flex-wrap gap-2">
                  <a
                    href={site.mapsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`location-maps-${i}`}
                    className="btn-secondary !py-2 !px-4 text-xs"
                  >
                    <i className="fa-solid fa-map" aria-hidden="true"></i>
                    Itinéraire
                  </a>
                  <a
                    href={SITE.phoneHref}
                    data-testid={`location-call-${i}`}
                    className="btn-primary !py-2 !px-4 text-xs"
                  >
                    <i className="fa-solid fa-phone" aria-hidden="true"></i>
                    Appeler
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Access info */}
        <div className="mt-10 rounded-2xl border border-border bg-[#F8FAFC] p-6 md:p-8 flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
          <div className="flex items-center gap-4">
            <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-navy text-white">
              <i className="fa-solid fa-wheelchair text-lg" aria-hidden="true"></i>
            </div>
            <div>
              <h3 className="font-display font-bold text-navy text-lg">
                {t.locations.accessTitle}
              </h3>
              <p className="mt-1 text-sm text-foreground/70">
                {t.locations.accessText}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Locations;
